import React from 'react';
import PropTypes from 'prop-types';

import RideDataInfoChart from './components/ride-data-info-chart/ride-data-info-chart';
import {
  CarBumpRegularIcon,
  SteeringWheelRegularIcon,
  VolumeRegularIcon
} from '../../shared/icons/icons';

function RideDataInfo(props) {
  const { className = '', handling, quiet, comfort, wetHandling } = props;
  const charts = [
    {
      Icon: VolumeRegularIcon,
      maxLabel: 'Quiet',
      minLabel: 'Loud',
      series: [
        {
          label: 'Tire Noise',
          value: quiet
        }
      ],
      title: 'Noise Level'
    },
    {
      Icon: CarBumpRegularIcon,
      maxLabel: 'Smooth',
      minLabel: 'Rough',
      series: [
        {
          label: 'Road Impact',
          value: comfort
        }
      ],
      title: 'Comfort'
    },
    {
      Icon: SteeringWheelRegularIcon,
      maxLabel: 'High',
      minLabel: 'Low',
      series: [
        {
          label: 'Steering Response',
          value: handling
        },
        {
          label: 'Wet Handling Response',
          value: wetHandling
        }
      ],
      title: 'Handling'
    }
  ];

  return (
    <div className={className}>
      {charts.map((chart, i) => (
        <RideDataInfoChart key={`chart-${i}`} {...chart} />
      ))}
    </div>
  );
}

RideDataInfo.propTypes = {
  className: PropTypes.string,
  comfort: PropTypes.number,
  handling: PropTypes.number,
  quiet: PropTypes.number,
  wetHandling: PropTypes.number
};

export default RideDataInfo;
